import { currencyToFloat } from './currency';

const brPhoneValidationRE = /\((11|12|13|14|15|16|17|18|19|21|22|24|27|28|31|32|33|34|35|37|38|41|42|43|44|45|46|47|48|49|51|53|54|55|61|62|63|64|65|66|67|68|69|71|73|74|75|77|79|81|82|83|84|85|86|87|88|89|91|92|93|94|95|96|97|98|99)\) [2-9][0-9]{7,8}/;
const messages = {
  'pt-BR': {
    required: 'Campo obrigatório',
    cylinderPrice: 'Este preço está muito fora do padrão',
    phone: 'Insira um telefone válido',
  },
  en: {
    required: 'Required field',
    cylinderPrice: 'This price is out of the regular price range',
    phone: 'Insert a valid phone',
  },
};

const getValidators = locale => {
  return {
    required: value => (value && String(value).length ? undefined : messages[locale].required),
    cylinderPrice: value => {
      const stringValue = String(value);
      const numberVal = currencyToFloat(stringValue);

      if (numberVal < 5 || numberVal > 200 || Number.isNaN(numberVal)) {
        return messages[locale].cylinderPrice;
      }

      return undefined;
    },
    phone: value => (brPhoneValidationRE.test(value) ? undefined : messages[locale].phone),
  };
};

export default getValidators;



// WEBPACK FOOTER //
// ../utils/functions/validators.js